"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCHING = 'dataFetching';
exports.FETCHED = 'dataFetched';
exports.FETCHING_ERROR = 'dataFetchingError';
exports.RESET_FETCHED = 'dataResetFetched';
exports.REMOVE_FETCHING_ERROR = 'dataRemoveFetchingError';
//# sourceMappingURL=action-types.js.map